import { Table, Tooltip, Typography } from "antd";
import routes from "@/routes";
import ContextMenu from "@/components/containers/ContextMenu";
import CollapsibleList from "@/components/ui/CollapsibleList";
import CustomLink from "@/components/ui/CustomLink";

const { Text } = Typography;

const KEY_ORIGIN = {
  SYSTEM: "system",
  USER_DEFINED: "user_defined",
};

const SYSTEM_NSPD_KEYS = {
  GEOMETRY_POLYGON: "geometry/polygon",
  GEOMETRY_POINT: "geometry/point",
};

const SYSTEM_NSPD_KEY_OPTIONS = [
  {
    label: "Геометрия: полигон",
    value: SYSTEM_NSPD_KEYS.GEOMETRY_POLYGON,
  },
  {
    label: "Геометрия: точка",
    value: SYSTEM_NSPD_KEYS.GEOMETRY_POINT,
  },
];

const getNspdKeyLabel = (item) => {
  const nspdKey = item?.nspd_key || null;

  if (!nspdKey) return "—";

  if (item?.nspd_key_origin !== KEY_ORIGIN.SYSTEM) {
    return nspdKey;
  }

  return (
    SYSTEM_NSPD_KEY_OPTIONS.find((option) => option.value === nspdKey)?.label ||
    nspdKey
  );
};

const disableDelete = (item) => {
  if (!item) return true;

  return Boolean(item.is_used);
};

const calcSortOrder = (sortedInfo, field) => {
  if (!sortedInfo) return null;

  const col = sortedInfo.find(({ columnKey }) => columnKey === field);

  return col ? col.order : null;
};

const NSPDKeyTable = ({
  data = [],
  loading = false,
  pagination,
  sortedInfo = [],
  onChange,
  onEditItem,
  onDeleteItem,
  scroll = { x: "100%" },
}) => {
  const columns = [
    {
      title: "Название",
      dataIndex: "name",
      key: "name",
      ellipsis: true,
      width: 200,
      sortOrder: calcSortOrder(sortedInfo, "name"),
      sorter: true,
      render: (value) => value || "—",
    },
    {
      title: "Поле запроса НСПД",
      dataIndex: "nspd_key",
      key: "nspd_key",
      width: 200,
      ellipsis: true,
      sortOrder: calcSortOrder(sortedInfo, "nspd_key"),
      sorter: true,
      render: (_, item) => getNspdKeyLabel(item),
    },
    {
      title: "Описание",
      dataIndex: "description",
      key: "description",
      ellipsis: true,
      width: 300,
      render: (description) =>
        description ? (
          <Tooltip title={description}>
            <Text
              style={{
                display: "inline-block",
              }}
              ellipsis
            >
              {description}
            </Text>
          </Tooltip>
        ) : (
          <></>
        ),
    },
    {
      title: "Категории",
      dataIndex: "categories",
      key: "categories",
      width: 250,
      render: (rowCategories = []) => {
        const categoryNames = rowCategories
          .map((category) => category.name)
          .filter(Boolean);

        if (!categoryNames.length) return "";

        return <CollapsibleList items={categoryNames} count={2} width={300} />;
      },
    },
    {
      title: "Типы ресурсов",
      dataIndex: "definitions",
      key: "definitions",
      width: 300,
      render: (definitions = []) => {
        const definitionsList = definitions.filter((d) => d?.name);

        if (!definitionsList.length) return "";

        return (
          <CollapsibleList count={2} width={300}>
            {definitionsList.map((defInfo) => (
              <CustomLink
                key={defInfo.uuid}
                to={routes.administration.resourcesSettings.structures.definitionDetail(
                  defInfo.type,
                  defInfo.uuid,
                )}
              >
                {defInfo.name}
              </CustomLink>
            ))}
          </CollapsibleList>
        );
      },
    },
    {
      title: "",
      width: 40,
      fixed: "right",
      align: "center",
      key: "actions",
      render: (_, item) => (
        <>
          {disableDelete(item) ? (
            <ContextMenu vertical onEdit={() => onEditItem(item)} />
          ) : (
            <ContextMenu
              vertical
              onEdit={() => onEditItem(item)}
              onDelete={() => onDeleteItem(item)}
            />
          )}
        </>
      ),
    },
  ];

  return (
    <Table
      dataSource={data}
      size="small"
      columns={columns}
      rowKey="uuid"
      loading={loading}
      pagination={pagination}
      onChange={onChange}
      showSorterTooltip={{
        target: "sorter-icon",
        title: "Нажмите для сортировки",
      }}
      scroll={scroll}
    />
  );
};

export default NSPDKeyTable;
